<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useMenuSlotsTracker } from '../../model/shift-control/menu-slots-tracker.hook'
import InfoSlotsTracker from './InfoSlotsTracker.vue'

defineOptions({
  name: 'MenuSlotsTracker',
})

const {
  config,
} = useMenuSlotsTracker()
</script>

<template>
  <div class="menu-tracker">
    <NavigationLinkTabs
      :config="config"
    />
    <InfoSlotsTracker />
  </div>
</template>

<style scoped lang="scss" src="./MenuSlotsTracker.scss" />
